import {Inject, Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {TISA_WICKET_TOKEN} from './tisa-wicket.providers';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(@Inject(TISA_WICKET_TOKEN) readonly token: (...args: any[]) => string) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(
      request.clone({
        setHeaders: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          Authorization:
            request.headers.get('Authorization') || this.authorizationHeader || '',
        },
      }),
    );
  }

  get authorizationHeader(): string {
    return this.token ? this.token() : '';
  }
}
